<template>Connexion ...</template>

<script>

export default {
    name: "login",
    data: () => {
        return {
            loading: false,
        };
    },

    methods: {
        async login() {
            this.loading = true;
            localStorage.clear();

            await this.$axios
                .post("auth/login/sso/" + this.$route.params.access_token)
                .then((r) => {
                    if (r.status === 200) {
                        localStorage.setItem("broker_token", r.data.access_token);
                        window.location.href = "/";
                    }
                })
                .catch((e) => {
                    this.errorData.message = e.response.data.message;
                }).finally(() => {
                    this.loading = false;
                });
        },
    },

    mounted() {
        this.login();
    },
};
</script>
